import { capabilityDefinition } from "../capabilities/registry.js";
/**
 * **أضيقُ نطاقٍ يُطلَب به** — فمن مُنع يطلب أقلَّ ما يفكّ عنه، لا أوسعَه.
 *
 * فشاشةُ المنع تسمّي القدرةَ الناقصة وتعرض طلبَها بضغطة — **ولم يكن أحدٌ
 * يوصّل تلك الضغطة بشيء**: لا الشاشة تطلب، ولا في النظام كلِّه طريقٌ آخر
 * يُنشئ طلبَ صلاحية. فكان `access_requests.create` قدرةً لها مسارٌ ولا بابَ له.
 *
 * **والنطاقُ لا يُسأل عنه المستخدم**: «قسم» و«عملاء مسندون» و«سجلّك» كلماتٌ
 * لا تعني موظّفاً مُنع من شاشة. فيُطلَب **أضيقُ ما تُجيزه القدرة**، ومن يبتّ
 * في الطلب يوسّعه إن شاء — فالتوسيعُ قرارُ من يملك، لا افتراضُ من يطلب.
 *
 * والترتيبُ هنا من الأضيق إلى الأوسع، **مكتوبٌ مرّةً** يقرؤه الطرفان.
 */
const NARROWEST_FIRST = [
    "own-record",
    "explicit-record",
    "assignee",
    "creator",
    "assigned-client",
    "department",
    "company",
];
export function narrowestRequestableScope(capability) {
    const allowed = capabilityDefinition(capability).allowedScopes;
    const pick = NARROWEST_FIRST.find((type) => allowed.includes(type));
    /**
     * **ونطاقُ القسم يُطلَب بـ«أقسامي» لا بمعرّفات** — فالموظّفُ لا يعرف معرّفَ
     * قسمه، والطلبُ يصير «ما أنا عضوٌ فيه» فيُقرَأ عند البتّ كما هو.
     */
    if (pick === "department")
        return { type: "department", of: "member" };
    if (pick === undefined)
        return { type: "company" };
    return { type: pick };
}
//# sourceMappingURL=request-scope.js.map